import { useCallback, useEffect } from "react";
import { useBeforeUnload, useBlocker, useNavigate } from "react-router";

/**
 * @param {boolean} shouldBlock
 * @memo tablet, sp の iOS での制御を追加する
 *
 * usage /src/hooks/use-transition-block/use-transition-block.md
 */

export const useTransitionBlock = (shouldBlock: boolean) => {
	const navigate = useNavigate();

	/**
	 * @see https://reactrouter.com/en/main/hooks/use-blocker
	 */
	const blocker = useBlocker(shouldBlock);

	const onBlockerReset = useCallback(() => {
		if (blocker.state !== "blocked") return;

		blocker.reset();
	}, [blocker]);

	const onTransition = useCallback(() => {
		if (blocker.state !== "blocked") return;

		blocker.proceed();
		navigate(blocker.location.pathname);
	}, [blocker, navigate]);

	useEffect(() => {
		if (blocker.state !== "blocked") return;

		const result = window.confirm("変更が保存されていません\nこのページを離れると、変更が失われます");
		if (result) {
			onTransition();
		} else {
			onBlockerReset();
		}
	}, [blocker.state, onBlockerReset, onTransition]);

	/**
	 * @description
	 * @see https://reactrouter.com/en/main/hooks/use-before-unload
	 * window.onbeforeunload の wrapper
	 */
	useBeforeUnload(
		useCallback(
			(e) => {
				if (!shouldBlock) return;

				e.preventDefault();
			},
			[shouldBlock],
		),
	);
};
